<h6 mat-dialog-title class="cropper-title">
  Crop image
  <span class="sub-text" *ngIf="imageCropper" matTooltip="File Name">({{ imageCropper.options.name }})</span>
</h6>

<mat-dialog-content>
  <div class="cropper-container flex-md-row flex-column">
    <div class="cropper">
      <image-cropper
        *ngIf="imageCropper"
        [class.hidden]="isLoading"
        [imageChangedEvent]="imageCropper.options.imageChangedEvent"
        [maintainAspectRatio]="imageCropper.options.maintainAspectRatio"
        [aspectRatio]="imageCropper.options.aspectRatio"
        [resizeToHeight]="imageCropper.options.outputHeight"
        [resizeToWidth]="imageCropper.options.outputWidth"
        [roundCropper]="imageCropper.options.roundCropper"
        [containWithinAspectRatio]="imageCropper.options.containWithinAspectRatio"
        [onlyScaleDown]="true"
        [imageQuality]="100"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="isLoading = false"></image-cropper>
      <div *ngIf="imageCropper.options.showAspectRatio" class="aspect-ratio-container" [class.d-none]="isLoading">
        <ng-container *ngFor="let aspectRatio of aspectRatioOptions">
          <button
            *ngIf="aspectRatio.value === imageCropper.options.aspectRatio"
            mat-raised-button
            type="button"
            color="primary"
            class="mat-primary-btn"
            (click)="changeAspectRatio(aspectRatio.value)">
            {{ aspectRatio.label }}
          </button>
        </ng-container>
      </div>
      <ng-container *ngIf="imageCropper.options.showAspectRatioSelection">
        <div class="aspect-ratio-container" [class.d-none]="isLoading">
          <button
            *ngFor="let aspectRatio of aspectRatioOptions"
            mat-raised-button
            type="button"
            [color]="imageCropper.options.aspectRatio === aspectRatio.value ? 'primary' : 'accent'"
            [class.mat-primary-btn]="imageCropper.options.aspectRatio === aspectRatio.value"
            [class.mat-accent-btn]="imageCropper.options.aspectRatio !== aspectRatio.value"
            (click)="changeAspectRatio(aspectRatio.value)">
            {{ aspectRatio.label }}
          </button>
        </div>
        <h6 class="mt-1 text-center" [class.d-none]="isLoading">Select Aspect Ratio</h6>
      </ng-container>
    </div>
    <div *ngIf="!isLoading" class="preview-container">
      <img [src]="croppedImageUrl" alt="Preview" class="preview" [class.radius]="imageCropper.options.roundCropper" />
      <h6 class="preview-label">Preview</h6>
    </div>
  </div>
  <div *ngIf="isLoading" class="text-center">
    <img [src]="imageLoader" alt="Loading..." class="image-loader" height="100" />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="cropper-footer">
  <button mat-raised-button type="button" color="accent" class="mat-accent-btn" (click)="closeCropper()">Cancel</button>
  <button mat-raised-button type="button" color="primary" class="mat-primary-btn" (click)="saveCroppedImage()">Done</button>
</mat-dialog-actions>
